import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertControl } from 'src/app/utils/alert/alert-control';
import { ConstantAlertType } from 'src/app/utils/common/constant-alert-type';
import { localize } from 'src/app/utils/localize/localize';
import { ContractObject } from 'src/app/utils/models/aas-models/contract/contract/contract-object.model';
import { FlowContract } from 'src/app/utils/models/aas-models/flow-contract/flow-contract.model';
import { PartnerDiscuss } from 'src/app/utils/models/aas-models/flow-contract/partner-discuss.model';
import { EmployeeService } from 'src/app/utils/services/aas-network/employee/employee.service';
import { FlowContractService } from 'src/app/utils/services/aas-network/flow-contract/flow-contract.service';
import { PartService } from 'src/app/utils/services/aas-network/part/part.service';
import { TemplateService } from 'src/app/utils/services/aas-network/template.service';
import { AuthService } from 'src/app/utils/services/auth.service';
import { LoadingService } from 'src/app/utils/services/loading.service';

@Component({
  selector: 'app-partner-discuss-modal',
  templateUrl: './partner-discuss-modal.component.html',
  styleUrls: ['./partner-discuss-modal.component.scss']
})
export class PartnerDiscussModalComponent implements OnInit {
  @Input('id')
  set id(value) { this._id = value; }
  get id() { return this._id; }
  _id: string = "";

  @Input('flowContract')
  set flowContract(value) { this._flowContract = new FlowContract(value); }
  get flowContract(): FlowContract { return this._flowContract; }
  _flowContract: FlowContract = new FlowContract();

  @Input('contract')
  set contract(value) { this._contract = new ContractObject(value); }
  get contract() { return this._contract; }
  _contract: ContractObject = new ContractObject();
  
  @Input('partnerEditable')
  set partnerEditable(value) { this._partnerEditable = value; }
  get partnerEditable() { return this._partnerEditable; }
  _partnerEditable: boolean = false;
  
  @Output() closed = new EventEmitter();
  
  localize = localize;

  flowContractSelected: FlowContract = null;
  partnerDiscuss: PartnerDiscuss[] = [];
  partnerDiscussError: any = null;
  isSubmit = false;

  constructor(
    private partService: PartService,
    private employeeService: EmployeeService,
    private templateService: TemplateService,
    private myAlert: AlertControl,
    private flowContractService: FlowContractService,
    private authService: AuthService,
    private router: Router,
    private activedRoute: ActivatedRoute,
    private loadingService: LoadingService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.viewDidLoad();
  }

  viewDidLoad() {
    this.flowContractSelected = new FlowContract(this.flowContract);
    
    this.setData(this.flowContract);
  }

  setData(param: FlowContract) {
    param.partnerDiscuss.forEach((item) => {
      let i = new PartnerDiscuss(item);
      i.setPerAction();
      this.partnerDiscuss.push(i);
    });
    console.log(this.partnerDiscuss);
  }

  addPartnerDiscuss() {
    this.partnerDiscuss.push(new PartnerDiscuss());
  }

  removePartnerDiscuss(index) {
    this.partnerDiscuss.splice(index, 1);
  }

  close() {
    this.closed.emit(null);
  }

  save() {
    this.isSubmit = true;
    this.checkValidate();

    if (this.partnerDiscussError) return;

    let flowContract: FlowContract = new FlowContract(this.flowContractSelected);
    flowContract.partnerDiscuss = this.partnerDiscuss;

    this.myAlert.showAlert(this.translate.instant('confirm_update_partner_discuss_config'), ConstantAlertType.BLANK, true, "", this.translate.instant('btn_confirm'), () => {
      this.postUpdatePartnerDiscuss(this.contract.contractId, this.getPartnerDiscussParam());
    }, "", this.translate.instant('btn_cancel'));

    // this.closed.emit(flowContract);
  }

  getPartnerDiscussParam() {
    let res = [];
    this.partnerDiscuss.forEach((item) => {
      res.push({
        "userId": item.userId || "",
        "departmentId": item.partyId || "",
        "permissions": item.permissions || []
      });
    })
    return res;
  }

  /**
   * Kiem tra du lieu cac bang
   */
   checkValidate() {
    this.partnerDiscussError = null;

    let arr = [];
    this.partnerDiscuss.forEach((item, index) => {
      item.checkValidate();
      arr.push({
        ...item,
        index: index
      })
      this.partnerDiscussError = {...this.partnerDiscussError, ...item.generalErrorValidate};
    });
    this.partnerDiscussError  && Object.keys(this.partnerDiscussError).length === 0 ? this.partnerDiscussError = null : this.partnerDiscussError;
  }

  /**
   * Quyen edit luong ky noi bo
   */
  get isCreator() {
    let isAdmin = this.authService.isAdmin;
    let isAm = this.authService.userId == this.contract.amId;
    return isAdmin || isAm;
  }

  postUpdatePartnerDiscuss(contractId, param) {
    this.flowContractService.postUpdatePartnerDiscuss(contractId, param).subscribe((res: any) => {
      this.myAlert.showAlertOnlyNoti(this.translate.instant('update_partner_discuss_config_success'), ConstantAlertType.SUCCESS);

      let flowContract: FlowContract = new FlowContract(this.flowContractSelected);
      flowContract.partnerDiscuss = this.partnerDiscuss;
      this.closed.emit(flowContract);
    }, err => {
      this.myAlert.showErrorHandled(err);
    })
  }
}
